import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import TheModel from "./pages/TheModel";
import Academics from "./pages/Academics";
import Admissions from "./pages/Admissions";
import Founder from "./pages/Founder";
import Enquire from "./pages/Enquire";
import FAQ from "./pages/FAQ";
import SummerCamp from "./pages/SummerCamp";
import Fees from "./pages/Fees";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

function App() {
  return (
    <div className="App min-h-screen bg-[#F9F8F4]">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/model" element={<TheModel />} />
            <Route path="/academics" element={<Academics />} />
            <Route path="/admissions" element={<Admissions />} />
            <Route path="/founder" element={<Founder />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/enquire" element={<Enquire />} />
            <Route path="/summer-camp" element={<SummerCamp />} />
            <Route path="/fees" element={<Fees />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
